import { DateRange, Option } from '@rp/shared/models';
import { DateUtil } from '@rp/utils';

const today = new Date();
const dow = (today.getDay() + 6) % 7;

export const datePickerPresets: Option<string, DateRange>[] = [
  {
    label: 'general.labels.today',
    value: {
      startDate: DateUtil.startOfTheDay(new Date()),
      endDate: DateUtil.endOfTheDay(new Date()),
    },
  },
  {
    label: 'general.labels.yesterday',
    value: {
      startDate: DateUtil.startOfTheDay(DateUtil.subtractDays(new Date(), 1)),
      endDate: DateUtil.endOfTheDay(DateUtil.subtractDays(new Date(), 1)),
    },
  },
  {
    label: 'general.labels.thisWeek',
    value: {
      startDate: DateUtil.startOfTheDay(DateUtil.subtractDays(today, dow)),
      endDate: DateUtil.endOfTheDay(today),
    },
  },
  {
    label: 'general.labels.lastWeek',
    value: {
      startDate: DateUtil.startOfTheDay(DateUtil.subtractDays(today, dow + 7)),
      endDate: DateUtil.endOfTheDay(DateUtil.subtractDays(today, dow + 1)),
    },
  },
  {
    label: 'general.labels.thisMonth',
    value: {
      startDate: DateUtil.startOfTheDay(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      ),
      endDate: DateUtil.endOfTheDay(new Date()),
    },
  },
  {
    label: 'general.labels.lastMonth',
    value: {
      startDate: DateUtil.startOfTheDay(
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      ),
      endDate: DateUtil.endOfTheDay(new Date(new Date().getFullYear(), new Date().getMonth(), 0)),
    },
  },
  {
    label: 'general.labels.thisYear',
    value: {
      startDate: DateUtil.startOfTheDay(new Date(new Date().getFullYear(), 0, 1)),
      endDate: DateUtil.endOfTheDay(new Date()),
    },
  },
  {
    label: 'general.labels.lastYear',
    value: {
      startDate: DateUtil.startOfTheDay(new Date(new Date().getFullYear() - 1, 0, 1)),
      endDate: DateUtil.endOfTheDay(new Date(new Date().getFullYear() - 1, 11, 31)),
    },
  },
  {
    label: 'general.labels.allTime',
    value: {
      startDate: DateUtil.startOfTheDay(new Date(0)), // January 1, 1970
      endDate: DateUtil.endOfTheDay(new Date()),
    },
  },
];
